import React from 'react'

const Sidebar = () => {
   
  return (
    <aside className="w-64 z-40 bg-black h-screen shadow-md bg-red px-1 absolute left-0 top-0" aria-label="Sidebar">
   <div className="overflow-y-auto py-40 px-3 ">
      <div className="flex flex-wrap flex-col justify-around">
          
           <a className="py-5 hover:text-white text-[#d2a960] text-2xl" href="/">HOME</a>    
          
          
           <a className="py-5 hover:text-white text-[#d2a960] text-2xl" href="/restaraunt">RESTARAUNT</a>    
          
          
           <a className="py-5 hover:text-white text-[#d2a960] text-2xl" href="/room">STAY</a>    
          
          
           <a className="py-5 hover:text-white text-[#d2a960] text-2xl" href="/halls">HALLS</a>    
          
          
           <a className="py-5 hover:text-white text-[#d2a960] text-2xl" href="/events">EVENTS</a>    
          
          
           <a className="py-5 hover:text-white text-[#d2a960] text-2xl" href="/menu">MENU</a>    
          
          
           <a className="py-5 hover:text-white text-[#d2a960] text-2xl" href="/gallery">GALLERY</a>    
          
          
           <a className="py-5 hover:text-white text-[#d2a960] text-2xl" href="/offer">OFFERS</a>    
          
       </div>
   </div>
</aside>
  )
}

export default Sidebar